var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVersions = function SvgVersions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 6A3 3 0 1 0 18 8.906V10.5a.75.75 0 0 1-.75.75H9c-.256 0-.51.044-.75.13V8.905a3 3 0 1 0-1.5 0v6.188a3 3 0 1 0 1.5 0V13.5a.75.75 0 0 1 .75-.75h8.25a2.25 2.25 0 0 0 2.25-2.25V8.906A3.006 3.006 0 0 0 21.75 6M6 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m3 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m9.75-10.5a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 2.999"
  })));
};
export default SvgVersions;